<!-- <a href="javascript:void(0)" data-bs-toggle="modal" (click)="openModal()">
  <ng-content></ng-content>
</a>


<div
  class="modal fade"
  [id]="'projectInfoModal_' + projectId"
  tabindex="-1"
  aria-labelledby="projectInfoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5">Project Info</h1>
      </div>

      <div class="modal-body">
        <div class="bg-light border rounded p-3 mb-4">
          <div class="row gy-2 gx-3">
            <div class="col-md-4">
              <b>Project Name:</b> {{ selectedProjectInfo?.projectName || "-" }}
            </div>
            <div class="col-md-4">
              <strong>Project Code:</strong>
              {{ selectedProjectInfo?.projCode || "-" }}
            </div>
            <div class="col-md-4">
              <strong>Unit Code:</strong>
              {{ selectedProjectInfo?.oUnitCodeName || "-" }}
            </div>
            <div class="col-md-4">
              <strong>Comp Code:</strong>
              {{ selectedProjectInfo?.compCode || "-" }}
            </div>
            <div class="col-md-4">
              <strong>Const Type:</strong>
              {{ selectedProjectInfo?.constType || "-" }}
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
 -->

<a
  class="text-decoration-none text-primary"
  href="javascript:void(0)"
  data-bs-toggle="modal"
  [attr.data-bs-target]="'#projectInfoModal_' + projectId"
  (click)="openModal()"
>
  <ng-content></ng-content>
</a>

<ng-template #projectInfoModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header justify-content-between d-flex pt-4">
      <h2 class="modal-title">Project Information</h2>
      <span (click)="modal.dismiss('Cross click')" role="button">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body pb-3">
      <div class="d-flex gap-3 align-items-center bg-body-tertiary p-3 rounded-3 mb-3">
        <ul class="list-unstyled m-0">
          <li>
            <span class="user-38"><i class="bi bi-folder lh-1"></i></span>
          </li>
        </ul>
        <div class="d-flex flex-column">
          <span class="fs-20 fw-500"> {{ selectedProjectInfo?.projectName || '-' }} </span>
          <span>{{ selectedProjectInfo?.projCode || '-' }}</span>
        </div>
      </div>
      <hr class="my-3 text-gray-300" />
      <h5 class="text-black fw-500 mb-2 fs-18">Organization Details</h5>
      <div class="row gy-2 gx-3 mt-3">
        <div class="col-md-6">
          <span class="fw-500 d-block">Unit Code:</span>
          {{ selectedProjectInfo?.unitCode || '-' }}
        </div>
        <div class="col-md-6">
          <span class="fw-500 d-block">Comp Code:</span>
          {{ selectedProjectInfo?.companyCode || '-' }}
        </div>
        <div class="col-md-6">
          <span class="fw-500 d-block">Construction Type:</span>
          {{ selectedProjectInfo?.constructionTypeCode || '-' }}
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" (click)="modal.dismiss('Cross click')" class="btn btn-secondary">Close</button>
    </div>
  </div>
</ng-template>
